export enum PageEnum {
  // 登录路径
  BASE_LOGIN = '/login',
  // 首页路径
  BASE_HOME = '/'
}
